<template>
  <div>
    <BaseTable
      :headers="tableHeaders"
      :items="participationList"
      :pagination="pagination"
      :loading="isLoading"
      :on-row-click="view"
      @update:page="getAll"
    >
      <template #item.viesas="{ item }">
        {{ !!item.viesas ? $t('common.yes') : $t('common.no') }}
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseTable from './base/BaseTable';
import tpdParticipationService from '@/services/tpd-participation.service';

export default {
  name: 'TpdParticipationProcessList',

  components: {BaseTable},

  props: {
    licId: {
      type: Number
    },
    profileId: {
      type: Number
    }
  },

  data() {
    return {
      isLoading: false,
      participationList: [],
      pagination: {},
      params: { licId: this.licId, profileId: this.profileId },
    };
  },

  computed: {
    tableHeaders() {
      const translationKey = 'pages.tpd.participationProcesses.table.headers';
      return [
        {text: this.$t(`${translationKey}.tpdrNr`), value: 'tpdr_nr'},
        {text: this.$t(`${translationKey}.nr`), value: 'nr'},
        {text: this.$t(`${translationKey}.name`), value: 'pavad'},
        {text: this.$t(`${translationKey}.category`), value: 'pl_rusis'},
        {text: this.$t(`${translationKey}.subCategory`), value: 'pl_porusis'},
        {text: this.$t(`${translationKey}.type`), value: 'pl_tipas'},
        {text: this.$t(`${translationKey}.stage`), value: 'etapas'},
        {text: this.$t(`${translationKey}.level`), value: 'terit_dydis_l'},
        {text: this.$t(`${translationKey}.registrationDate`), value: 'reg_data'},
        {text: this.$t(`${translationKey}.startDate`), value: 'pradzia'},
        {text: this.$t(`${translationKey}.removalDate`), value: 'i_data'},
        {text: this.$t(`${translationKey}.isPublic`), value: 'viesas'}
      ];
    },
  },

  created() {
    this.getAll();
  },

  methods: {
    getAll(page = 1) {
      this.isLoading = true;
      const params = {...this.params, page };
      tpdParticipationService
        .getProcessList(params)
        .then((res) => {
          this.participationList = res.data.tpd;
          this.pagination = {
            page: res.data.page,
            total: res.data.total,
            pageSize: res.data.pageSize,
          };
        })
        .catch(() => {
          this.participationList = [];
          this.pagination = {};
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    view(item) {
      window.location.href = this.$url(item.url);
    },
  },
};
</script>
